import {PumpeCCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const PumpeCCRequestInit = () => {
    return {
        type:PumpeCCActionType.PumpeCC_INIT
    }
}

export const PumpeCCSuccess = (
    objeckt: any
) => {
    return {
        type: PumpeCCActionType.PumpeCC_INIT,
        objeckt: objeckt
    }
}

export const getPumpeCC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            PumpeCCSuccess(
                objeckt
            )
        )
    }
}
